<template>
    <div class="z-10">
        <PageComponent 
            :loader="loader" @showLoader="showLoader" @hideLoader="hideLoader"
            :addButtonLabel="addButtonLabel"
            :showAddButton=false
            @handleAddNew="addNewOvertime"
            :searchFilters="searchFilters"
            @searchPage="searchOvertimes"
            @resetFilters="resetFilters"
            @removeItem="removeDeduction"
            @removeSelectedItems="removeDeductions"
            @printList="printCasesList"
            @printExcel="downloadCasesExcel"
            @printCSV="downloadCasesCSV"
            :addingRight="addingRight"
            :removingRight="removingRight"
            :rightsModule="rightsModule"
            :columns="tableColumns"
            :rows="deductionsList"
            :actions="actions"
            :showActions=false
            :idField="idField"
            @handleSelectionChange="handleSelectionChange"
            @handleActionClick="handleActionClick"
            :count="propCount"
            :currentPage="currentPage"
            :result="propArrLen"
            @loadPrev="loadPrev"
            @loadNext="loadNext"
            @firstPage="firstPage"
            @lastPage="lastPage"
            :showNextBtn="showNextBtn"
            :showPreviousBtn="showPreviousBtn"
            :selectedValue="selectedValue"
            @selectSearchQuantity="selectSearchQuantity"
        />
        <MovableModal v-model:visible="propModalVisible" :title="title" :modal_top="modal_top" :modal_left="modal_left" :modal_width="modal_width"
            :loader="modal_loader" @showLoader="showModalLoader" @hideLoader="hideModalLoader" @closeModal="closeModal">
            <DynamicForm 
                :fields="formFields" :flex_basis="flex_basis" :flex_basis_percentage="flex_basis_percentage" 
                :displayButtons="displayButtons" @handleSubmit="saveDeduction" @handleReset="handleReset"
            />
        </MovableModal>
        <MovableModal v-model:visible="transModalVisible" :title="transTitle" :modal_top="modal_top" :modal_left="modal_left" :modal_width="modal_width"
            :loader="trans_modal_loader" @showLoader="showTransModalLoader" @hideLoader="hideTransModalLoader" @closeModal="closeTransModal">
            <DynamicForm 
                :fields="formFields1" :flex_basis="flex_basis" :flex_basis_percentage="flex_basis_percentage" 
                :displayButtons="displayButtons" @handleSubmit="approveOvertime" @handleReset="handleReset1"
            />
        </MovableModal>
    </div>
</template>

<script>
import axios from "axios";
import { ref, computed, onMounted, onBeforeMount, watch} from 'vue';
import PageComponent from '@/components/PageComponent.vue';
import MovableModal from '@/components/MovableModal.vue'
import DynamicForm from '../NewDynamicForm.vue';
import { useStore } from "vuex";
import { useToast } from "vue-toastification";
import { useDateFormatter } from '@/composables/DateFormatter';
import PrintJS from 'print-js';

export default{
    name: 'Employee_Overtime',
    components:{
        PageComponent, MovableModal,DynamicForm
    },
    setup(){
        const store = useStore();     
        const toast = useToast();
        const { getYear } = useDateFormatter();
        const { getMonth } = useDateFormatter();
        const current_date = new Date();
        const loader = ref('none');
        const modal_loader = ref('none');
        const trans_modal_loader = ref('none');
        const emplComponentKey = ref(0);
        const levComponentKey = ref(0);
        const idField = 'employee_overtime_id';
        const addButtonLabel = ref('New Overtime');
        const addingRight = ref('Adding Overtime Policies');
        const removingRight = ref('Deleting Overtime Policies');
        const rightsModule = ref('HR');
        const title = ref('Overtime Details');
        const transTitle = ref('Approve Overtime'); 
        const submitButtonLabel = ref('Add');
        const selectedIds = ref([]);
        const deductionsList = ref([]);
        const propResults = ref([]);
        const propArrLen = ref(0);
        const propCount = ref(0);
        const pageCount = ref(0);
        const selectedValue = ref(50);
        const currentPage = ref(1);
        const showNextBtn = ref(false);
        const showPreviousBtn = ref(false);
        const propModalVisible = ref(false);
        const transModalVisible = ref(false);
        const flex_basis = ref('');
        const flex_basis_percentage = ref('');
        const displayButtons = ref(true);
        const errors = ref([]);
        const modal_top = ref('150px');
        const modal_left = ref('500px');
        const modal_width = ref('30vw');
        const policyID = ref('');
        const employeeID = ref('');
        const overtimeID = ref('');
        const isEditing = computed(()=> store.state.Employee_Overtime.isEditing);
        const selectedOvertime = computed(()=> store.state.Employee_Overtime.selectedOvertime);
        const selectedPolicy = computed(()=> store.state.Employee_Overtime.selectedPolicy);
        const selectedEmployee = computed(()=> store.state.Employee_Overtime.selectedEmployee);
        const overtimeArray = computed(() => store.state.Overtime.overtimeArr);
        const employeeArray = computed(() => store.state.Employees.employeeArr);
        const showModal = ref(false);
        const tableColumns = ref([
            {type: "checkbox"},
            {label: "Date", key: "date"},
            {label: "Staff No", key: "staff_number"},
            {label: "Employee Name", key: "employee_name"},
            {label: "Overtime", key: "overtime_policy_name"},
            {label: "Hours", key: "hours"},
            {label: "Mins", key: "minutes"},
            {label: "Description", key: "description"},
            {label: "Appr. Status", key: "approval_status", textColor: "statusColor"},
            {label: "Approved By", key: "approved_by"},
            
        ])
        const actions = ref([
            {name: 'edit', icon: 'fa fa-edit', title: 'Edit Overtime', rightName: 'Editing Overtime Policies'},
            {name: 'approve/reject', icon: 'fa fa-check-circle', title: 'Approve/Reject Overtime', rightName: 'Approving Employee Overtime'},
            {name: 'delete', icon: 'fa fa-trash', title: 'Delete Overtime', rightName: 'Deleting Overtime Policies'},
        ])
        const companyID = computed(()=> store.state.userData.company_id);
        const userID = computed(()=> store.state.userData.user_id);
        const employee_name_search = ref('');
        const staff_number_search = ref('');
        const from_date_search = ref('');
        const to_date_search = ref('');
        const searchFilters = ref([
            {type:'text', placeholder:"Staff No...", value: staff_number_search, width:32,},
            {type:'text', placeholder:"Employee Name...", value: employee_name_search, width:64,},
            {type:'date', placeholder:"From Date...", value: from_date_search, width:32,},
            {type:'date', placeholder:"To Date...", value: to_date_search, width:32,},
        ]);
        const handleSelectionChange = (ids) => {
            selectedIds.value = ids;
        };
        const fetchEmployees = async() =>{
            await store.dispatch('Employees/fetchEmployees', {company:companyID.value});
        };
        const handleSelectedEmployee = async(option) =>{
            await store.dispatch('Employees/handleSelectedEmployee', option)
            employeeID.value = store.state.Employees.employeeID;
        };
        const clearSelectedEmployee = async() =>{
            await store.dispatch('Employees/updateState', {employeeID: ''});
            employeeID.value = store.state.Employees.employeeID;
        };
        const fetchOvertimePolicies = async() =>{
            await store.dispatch('Overtime/fetchOvertimePolicies', {company:companyID.value});
        };
        const handleSelectedPolicy = async(option) =>{
            await store.dispatch('Overtime/handleSelectedOvertime', option)
            policyID.value = store.state.Overtime.overtimeID;
        };
        const clearSelectedPolicy = async() =>{
            await store.dispatch('Overtime/updateState', {overtimeID: ''});
            policyID.value = store.state.Overtime.overtimeID;
        };
        const formFields = ref([]);

        const employeeValue = computed(() => {
           return (selectedOvertime.value && selectedOvertime.value.employee && !policyID.value) ? selectedOvertime.value.employee.employee_id : employeeID.value;

        });

        const policyValue = computed(() => {
           return (selectedOvertime.value && selectedOvertime.value.overtime_policy && !policyID.value) ? selectedOvertime.value.overtime_policy.overtime_policy_id : policyID.value;

        });
        const updateFormFields = () => {
            formFields.value = [
                {  
                    type:'search-dropdown', label:"Employee", value: employeeValue.value, componentKey: emplComponentKey,
                    selectOptions: employeeArray, optionSelected: handleSelectedEmployee, required: true,
                    searchPlaceholder: 'Select Employee...', dropdownWidth: '500px', updateValue: selectedEmployee.value,
                    clearSearch: clearSelectedEmployee
                },
                {  
                    type:'search-dropdown', label:"Overtime Policy", value: policyValue.value, componentKey: levComponentKey,
                    selectOptions: overtimeArray, optionSelected: handleSelectedPolicy, required: true,
                    searchPlaceholder: 'Select Overtime Policy...', dropdownWidth: '500px', updateValue: selectedPolicy.value,
                    clearSearch: clearSelectedPolicy
                },
                { type: 'date', name: 'date',label: "Date", value: selectedOvertime.value?.date, required: true },
                { type: 'number', name: 'hours',label: "Hours", value: selectedOvertime.value?.hours || 0, required: true }, 
                { type: 'number', name: 'minutes',label: "Minutes", value: selectedOvertime.value?.minutes || 0, required: false }, 
                {type:'text-area', label:"Description", value: selectedOvertime.value?.description || '', textarea_rows: '4', textarea_cols: '56', required: false},                                                                        
            ];
        };
        const handleReset = () =>{
            for(let i=0; i < formFields.value.length; i++){
                formFields.value[i].value = '';
            }
            levComponentKey.value += 1;
            policyID.value = '';
            emplComponentKey.value += 1;
            employeeID.value = '';
        }


        watch([selectedOvertime, selectedEmployee, selectedPolicy], () => {
            if (selectedOvertime.value && selectedEmployee.value && selectedPolicy.value) {
                levComponentKey.value += 1;
                emplComponentKey.value += 1;
                updateFormFields();
            }
            
        }, { immediate: true });
        
        
        const showModalLoader = () =>{
            modal_loader.value = "block";
        }
        const hideModalLoader = () =>{
            modal_loader.value = "none";
        }
        const createEmployeeOvertime = async() =>{
            showModalLoader();
            let formData = {
                date: formFields.value[2].value,
                description: formFields.value[5].value,
                hours: formFields.value[3].value,
                minutes: formFields.value[4].value,
                approval_status: "Pending",
                approved_by: null,
                overtime_policy: policyID.value,
                overtime_policy_id: policyID.value,
                employee: employeeID.value,
                employee_id: employeeID.value,
                company: companyID.value
            }
  
            errors.value = [];
            for(let i=1; i < formFields.value.length; i++){
                if(formFields.value[i].value =='' && formFields.value[i].type != 'search-dropdown' && formFields.value[i].required == true){
                    errors.value.push(formFields.value[i].label);
                }
            }
            if(policyValue.value == '' || employeeValue.value == ''){
                errors.value.push('error')
            }

            if(errors.value.length){
                toast.error('Fill In Required Fields');
                hideModalLoader();
            }else{
                try {
                    const response = await store.dispatch('Employee_Overtime/createEmployeeOvertime', formData);
                    if (response && response.status === 201) {
                        hideModalLoader();
                        toast.success('Overtime created successfully!');
                        handleReset();
                        emplComponentKey.value += 1;
                        levComponentKey.value += 1;
                    }
                    else {
                        toast.error('An error occurred while creating the Overtime.');
                    }
                } catch (error) {
                    console.error(error.message);
                    toast.error('Failed to create Overtime: ' + error.message);
                } finally {
                    hideModalLoader();
                    searchOvertimes();
                }
            }
        }
        const updateEmployeeOvertime = async() =>{
            showModalLoader();
            errors.value = [];
            let formData = {
                employee_overtime: selectedOvertime.value.employee_overtime_id,
                date: formFields.value[2].value,
                description: formFields.value[5].value,
                hours: formFields.value[3].value,
                minutes: formFields.value[4].value,
                approval_status: selectedOvertime.value.approval_status,
                approved_by: selectedOvertime.value.approved_by,
                overtime_policy: policyValue.value,
                overtime_policy_id: policyValue.value,
                employee: employeeValue.value,
                employee_id: employeeValue.value,
                company: companyID.value
            }

            for(let i=0; i < formFields.value.length; i++){
                if(formFields.value[i].value =='' && formFields.value[i].type != 'search-dropdown'  && formFields.value[i].required == true){
                    errors.value.push('Error');
                }
            }
            if(policyValue.value == '' || employeeValue.value == ''){
                errors.value.push('error')
            }
            if(errors.value.length){
                toast.error('Fill In Required Fields');
                hideModalLoader();
            }else{
                try {
                    const response = await store.dispatch('Employee_Overtime/updateEmployeeOvertime', formData);
                    if (response && response.status === 200) {
                        hideModalLoader();
                        handleReset();
                        emplComponentKey.value += 1;
                        toast.success("Overtime updated successfully!");              
                    } else {
                        toast.error('An error occurred while updating the Overtime.');
                    }
                } catch (error) {
                    console.error(error.message);
                    toast.error('Failed to update Overtime: ' + error.message);
                } finally {
                    hideModalLoader();
                    propModalVisible.value = false;
                    store.dispatch("Employee_Overtime/updateState",{selectedOvertime:null})
                    searchOvertimes();
                }             
            }
        }
        const saveDeduction = () =>{
            if(isEditing.value == true){
                updateEmployeeOvertime();
            }else{
                createEmployeeOvertime();
            }
        }
        const removeDeduction = async() =>{
            if(selectedIds.value.length == 1){
                let formData = {
                    company: companyID.value,
                    employee_overtime: selectedIds.value
                }
                try{
                    const response = await store.dispatch('Employee_Overtime/deleteEmployeeOvertime',formData)
                    if(response && response.status == 200){
                        toast.success("Overtime Removed Succesfully");
                        searchOvertimes();
                    }
                }
                catch(error){
                    console.error(error.message);
                    toast.error('Failed to remove Overtime: ' + error.message);
                }
                finally{
                    selectedIds.value = [];
                }
            }else if(selectedIds.value.length > 1){
                toast.error("You have selected more than 1 Overtime") 
            }else{
                toast.error("Please Select An Overtime To Remove")
            }
        }
        const removeDeductions = async() =>{
            if(selectedIds.value.length){
                let formData = {
                    company: companyID.value,
                    employee_overtime: selectedIds.value
                }
                try{
                    const response = await store.dispatch('Employee_Overtime/deleteEmployeeOvertime',formData)
                    if(response && response.status == 200){
                        toast.success("Overtime(s) Removed Succesfully");
                        searchOvertimes();
                    }
                }
                catch(error){
                    console.error(error.message);
                    toast.error('Failed to remove Overtime: ' + error.message);
                }
                finally{
                    selectedIds.value = [];

                }
            }else{
                toast.error("Please Select An Overtime To Remove")
            }
        }
        const showLoader = () =>{
            loader.value = "block";
        }
        const hideLoader = () =>{
            loader.value = "none";
        }
        const searchOvertimes = () =>{
            showLoader();
            showNextBtn.value = false;
            selectedIds.value = [];
            showPreviousBtn.value = false;
            let formData = {
                employee_name: employee_name_search.value,
                staff_number: staff_number_search.value,
                date_from: from_date_search.value,
                date_to: to_date_search.value,
                user: userID.value,
                company_id: companyID.value,
                page_size: selectedValue.value
            } 
            axios
            .post(`api/v1/employee-overtimes-search/?page=${currentPage.value}`,formData)
            .then((response)=>{
                deductionsList.value = response.data.results;
                store.commit('Employee_Overtime/LIST_OVERTIMES', deductionsList.value)
                propResults.value = response.data;
                propArrLen.value = deductionsList.value.length;
                propCount.value = propResults.value.count;
                pageCount.value = Math.ceil(propCount.value / selectedValue.value);
                if(response.data.next){
                    showNextBtn.value = true;
                }
                if(response.data.previous){
                    showPreviousBtn.value = true;
                }
            })
            .catch((error)=>{
                console.log(error.message);
            })
            .finally(()=>{
                hideLoader();
            })
        };
        const selectSearchQuantity = (newValue) =>{
            selectedValue.value = newValue;
            searchOvertimes(selectedValue.value);
        };
        const resetFilters = () =>{
            currentPage.value = 1;
            selectedValue.value = 50;
            staff_number_search.value = "";
            employee_name_search.value = "";
            from_date_search.value = "";
            to_date_search.value = "";
            searchOvertimes();
        }
        const loadPrev = () =>{
            if (currentPage.value <= 1){
                currentPage.value = 1;
            }else{
                currentPage.value -= 1;
            }
            
            searchOvertimes();
            // scrollToTop();
        }
        const loadNext = () =>{
            if(currentPage.value >= pageCount.value){
                currentPage.value = pageCount.value;
            }else if(currentPage.value < pageCount.value){
                currentPage.value += 1;
            }
            
            searchOvertimes();
            // scrollToTop(); 
        }
        const firstPage = ()=>{
            currentPage.value = 1;
            searchOvertimes();
            // scrollToTop();
        }
        const lastPage = () =>{
            currentPage.value = pageCount.value;
            searchOvertimes();
            // scrollToTop();
        }
        const addNewOvertime = () =>{
            store.dispatch("Employee_Overtime/updateState",{selectedOvertime:null,selectedEmployee:null,selectedPolicy:null});
            emplComponentKey.value += 1;
            levComponentKey.value += 1;
            handleReset();
            updateFormFields();
            propModalVisible.value = true;
            store.dispatch("Employee_Overtime/updateState",{isEditing:false})
            flex_basis.value = '1/3';
            flex_basis_percentage.value = '33.333';
        }
        const handleActionClick = async(rowIndex, action, row) =>{
            if( action == 'edit'){
                const advanceID = row['employee_overtime_id'];
                const approvalStatus = row['approval_status'];
                if(approvalStatus == "Pending"){
                    let formData = {
                        company: companyID.value,
                        employee_overtime: advanceID
                    }
                    await store.dispatch('Employee_Overtime/fetchEmployeeOvertime',formData)
                    propModalVisible.value = true;
                    flex_basis.value = '1/3';
                    flex_basis_percentage.value = '33.333';
                }else{
                    toast.error(`Cannot Edit ${approvalStatus} Overtime`)
                }
                

            }else if(action == 'delete'){
                const advanceID = [row[idField]];
                let formData = {
                    company: companyID.value,
                    employee_overtime: advanceID
                }
                await store.dispatch('Employee_Overtime/deleteEmployeeOvertime',formData).
                then(()=>{
                    searchOvertimes();
                })
            }else if(action == 'approve/reject'){
                const applicationStatus = row['approval_status']
                if(applicationStatus == 'Pending'){
                    updateFormFields1();
                    overtimeID.value = row['employee_overtime_id'];
                    transModalVisible.value = true;
                    flex_basis.value = '1/2';
                    flex_basis_percentage.value = '50';
                }else{
                    toast.error(`Overtime Already ${applicationStatus}`)
                }
            }
        }
        const closeModal = () =>{
            propModalVisible.value = false;
        };
        const printCasesList = () =>{
            showLoader();
            let formData = {
                employee_name: employee_name_search.value,
                staff_number: staff_number_search.value,
                company_id: companyID.value,
            } 

            axios
            .post("api/v1/export-disciplinary-meetings-pdf/", formData, { responseType: 'blob' })
                .then((response)=>{
                    if(response.status == 200){
                        const blob1 = new Blob([response.data]);
                        // Convert blob to URL
                        const url = URL.createObjectURL(blob1);
                        PrintJS({printable: url, type: 'pdf'});
                    }
                })
            .catch((error)=>{
                console.log(error.message);
            })
            .finally(()=>{
                hideLoader();
            })
        };
        const downloadCasesExcel = () =>{
            showLoader();
            let formData = {
                employee_name: employee_name_search.value,
                staff_number: staff_number_search.value,
                status: status_search.value,
                company_id: companyID.value,
            }
            axios.post("api/v1/export-disciplinary-meetings-excel/", formData, { responseType: 'blob' })
            .then((response)=>{
                if(response.status == 200){
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Disciplinary Meetings.xlsx');
                document.body.appendChild(link);
                link.click();
                }
            })
            .catch((error)=>{
                console.log(error);
            })
            .finally(()=>{
                hideLoader();
            })
        };
        const downloadCasesCSV = () =>{
            showLoader();
            let formData = {
                employee_name: employee_name_search.value,
                staff_number: staff_number_search.value,
                company_id: companyID.value,
            }
            axios.post("api/v1/export-disciplinary-meetings-csv/", formData, { responseType: 'blob' })
            .then((response)=>{
                if(response.status == 200){
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Disciplinary Meetings.csv');
                document.body.appendChild(link);
                link.click();
                }
            })
            .catch((error)=>{
                console.log(error);
            })
            .finally(()=>{
                hideLoader();
            })
        };
        const formFields1 = ref([]);
        const updateFormFields1 = () => {
            formFields1.value = [
                { type: 'dropdown', name: 'approval_status',label: "Status", value: '', placeholder: "", required: true, options: [{ text: 'Approve', value: 'Approved' }, { text: 'Reject', value: 'Rejected' }] },
            ]
        };
        const handleReset1 = () =>{
            for(let i=0; i < formFields1.value.length; i++){
                formFields1.value[i].value = '';
            }
        };
        const showTransModalLoader = () =>{
            trans_modal_loader.value = "block";
        }
        const hideTransModalLoader = () =>{
            trans_modal_loader.value = "none";
        }
        const approveOvertime = async() =>{
            showTransModalLoader();
            let formData = {
                employee_overtime: overtimeID.value,
                approved_by: userID.value,
                approval_status: formFields1.value[0].value,
                company: companyID.value
            }

            axios.post(`api/v1/approve-employee-overtime/`,formData)
            .then((response)=>{
            if(response.data.msg == "Success"){
                hideTransModalLoader();
                closeTransModal();
                toast.success("Success")
                searchOvertimes();
            }else{
                toast.error("Error");
                hideTransModalLoader();
            }                   
            })
            .catch((error)=>{
                toast.error(error.message);
                hideTransModalLoader();
            })
        };
        const closeTransModal = () =>{
            transModalVisible.value = false;
            overtimeID.value = null;
            hideTransModalLoader();
        };
        onBeforeMount(()=>{
            searchOvertimes();
            fetchEmployees();
            fetchOvertimePolicies();
        })
        return{
            title, searchOvertimes,resetFilters, addButtonLabel, searchFilters, tableColumns, deductionsList,
            currentPage,propResults, propArrLen, propCount, pageCount, showNextBtn, showPreviousBtn,
            loadPrev, loadNext, firstPage, lastPage, idField, actions, handleActionClick, propModalVisible, closeModal,
            submitButtonLabel, showModal, addNewOvertime, showLoader, loader, hideLoader, modal_loader, modal_top, modal_left, modal_width,displayButtons,
            showModalLoader, hideModalLoader, saveDeduction, formFields, handleSelectionChange, flex_basis,flex_basis_percentage,
            removeDeduction, removeDeductions,addingRight,removingRight,rightsModule,printCasesList,selectSearchQuantity,selectedValue,
            downloadCasesCSV,downloadCasesExcel,trans_modal_loader,transTitle,transModalVisible,showTransModalLoader,hideTransModalLoader,closeTransModal,
            approveOvertime,formFields1,handleReset1
        }
    }
};
</script>